import { useEffect, useState, useContext } from 'react';
import {
  Alert,
  Box,
  TextField,
  Autocomplete,
} from '@mui/material';
import { Link } from "react-router-dom";

import { Departments, availableCategoryGroups, AuthContext } from 'components';


export const CategoryField = (props) => {
  const { category } = props;
  const [ value, setValue ] = useState(category);
  const { customCategories } = useContext(AuthContext);
  const [ selectedCategoryGroups, setSelectedCategoryGroups ] = useState([]);
  const [ selectedDepartment, setSelectedDepartment ] = useState(null);

  useEffect(() => {
    if (!customCategories) return
    setSelectedCategoryGroups([...new Set(Object.keys(customCategories).map((e) => customCategories[e].category_group))])
  }, [customCategories])
  
  // If no custom categories, simply not render the field
  if (!Object.keys(customCategories).length) {
    return <Alert severity="warning">You don't have any categories. You can add some <Link to='/categories' >here</Link></Alert>
  }

  const visibleEditCategories = Object.keys(customCategories).map((c) => ({
    ...customCategories[c],
    id: c
  })).filter((c) => c.category_group === selectedDepartment).sort((a, b) => a.sorting?.indexOf(a.id) > b.sorting?.indexOf(b.id) ? 1 : -1)

  return (
    <>
      <Departments department={customCategories[category]?.category_group} preselectDepartment={false} onChange={setSelectedDepartment} />
      { selectedDepartment ? (
        <Autocomplete
          id="grouped-demo"
          value={value}
          isOptionEqualToValue={(option, value) => {
            return option.category_id === value
          }}
          options={visibleEditCategories}
          onChange={(event, value) => {
            if (!value) return
            if (props.onChange) { 
              props.onChange({
                categoryId: value.id,
                categoryType: availableCategoryGroups.indexOf(selectedDepartment)
              })
            }
            setValue(value.id)
          }}
          getOptionLabel={(option) => option.category || customCategories[option]?.category || "" }
          sx={{ width: 300 }}
          renderOption={(props, option, state, ownerState) => {
            const { key, ...optionProps } = props;
            return (
              <Box
                key={option.id}
                component="li"
                {...optionProps}
              >
                {ownerState.getOptionLabel(option)}
              </Box>
            );
          }}
          renderInput={(params) => <TextField {...params} variant="standard" placeholder="Select category" />}
        />
      ) : null}
    </>
  )
}